import {
  ButtonPlacements,
  Carousel as DsCarousel,
} from '@picsart/design-system/components/Carousel';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import extractTextFromHTML from 'templates/utils/extractTextFromHTML';
import { useDeviceType } from '@picsart/design-system/components/hooks';
import BannerCarouselItem from '../BannerCarouselItem';
import { CarouselProps } from './types';
import useStyles from './styles';
import { dataTestIds } from '../constants';

const Carousel = ({ bannerItems, bannerTitle }: CarouselProps) => {
  const classes = useStyles();
  const isMobile = useDeviceType();

  return (
    <div
      className={classes.root}
      data-pulse-section={extractTextFromHTML(bannerTitle)}
      data-testid={dataTestIds.bannerCarousel}
    >
      <DsCarousel
        isMultiSlide
        hideArrows={isMobile}
        dataTestId="templates-carousel"
        gap={Spacings.s16}
        buttonPlacement={ButtonPlacements.Overhang}
        scrollAmount={476}
      >
        {bannerItems.map(bannerItem => (
          <BannerCarouselItem key={bannerItem.title} bannerItem={bannerItem} />
        ))}
      </DsCarousel>
    </div>
  );
};

export default Carousel;
